import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MFEPackageIds } from '@interfaces/open-choice/mfe-details.enum';
import { mfeResolver } from '@shared/mfe-resolver/mfe.resolver';
import { SettlementFundComponent } from '@src/app/secure/settlement-fund/containers/settlement-fund/settlement-fund.component';
import { SettlementFundModule } from '@src/app/secure/settlement-fund/settlement-fund.module';

import { AuthGuard } from './core/guards/auth/auth.guard';

export const internalTransferRoutes: Routes = [
  {
    path: 'internal-transfer',
    children: [
      {
        path: 'overview',
        loadChildren: () =>
          import('./public/internal-transfer-overview/internal-transfer-overview.module').then(
            (m) => m.InternalTransferOverviewModule,
          ),
      },
      {
        path: 'triage',
        loadChildren: () =>
          import('./public/internal-transfer-triage/internal-transfer-triage.module').then(
            (m) => m.InternalTransferTriageModule,
          ),
      },
      {
        path: 'summary',
        loadChildren: () =>
          import('./public/internal-transfer-summary/internal-transfer-summary.module').then(
            (m) => m.InternalTransferSummaryModule,
          ),
      },
    ],
  },
  {
    path: 'secure/internal-transfer',
    canActivate: [AuthGuard],
    children: [
      {
        path: 'contact-info',
        loadChildren: () =>
          import('./secure/contact-info/contact-info.module').then((m) => m.ContactInfoModule),
      },
      {
        path: 'cost-basis-opt-in',
        loadChildren: () =>
          import(
            './secure/internal-transfer-cost-basis-opt-in/internal-transfer-cost-basis-opt-in.module'
          ).then((m) => m.InternalTransferCostBasisOptInModule),
      },
      {
        path: 'different-owner-recipient',
        loadChildren: () =>
          import(
            './secure/internal-transfer-different-owner-recipient/internal-transfer-different-owner-recipient.module'
          ).then((m) => m.InternalTransferDifferentOwnerRecipientModule),
      },
      {
        path: 'employment',
        loadChildren: () =>
          import('./secure/employment/employment.module').then((m) => m.EmploymentModule),
      },
      {
        path: 'expired',
        loadChildren: () =>
          import('./secure/internal-transfer-expired/internal-transfer-expired.module').then(
            (m) => m.InternalTransferExpiredModule,
          ),
      },
      {
        path: 'holdings-review',
        loadChildren: () =>
          import(
            './secure/internal-transfer-holdings-review/containers/internal-transfer-holdings-review-classic/internal-transfer-holdings-review-classic.module'
          ).then((m) => m.InternalTransferHoldingsReviewClassicModule),
      },
      {
        path: 'holdings-review-multisigner',
        loadChildren: () =>
          import(
            './secure/internal-transfer-holdings-review/containers/internal-transfer-holdings-review-simple/internal-transfer-holdings-review-simple.module'
          ).then((m) => m.InternalTransferHoldingsReviewSimpleModule),
      },
      {
        path: 'open-account',
        loadChildren: () =>
          import(
            './secure/internal-transfer-open-account/internal-transfer-open-account.module'
          ).then((m) => m.InternalTransferOpenAccountModule),
      },
      {
        path: 'personal-info',
        loadChildren: () =>
          import('./secure/personal-info/personal-info.module').then((m) => m.PersonalInfoModule),
      },
      {
        path: 'settlement-fund',
        loadChildren: () =>
          import('./secure/settlement-fund/settlement-fund.module').then(
            (m) => m.SettlementFundModule,
          ),
      },
      {
        path: 'terms',
        loadChildren: () => import('./secure/terms/terms.module').then((m) => m.TermsModule),
      },
      {
        path: 'transfer-details',
        loadChildren: () =>
          import('./secure/internal-transfer-details/internal-transfer-details.module').then(
            (m) => m.InternalTransferDetailsModule,
          ),
      },
      {
        path: 'transfer-from',
        loadChildren: () =>
          import('./secure/internal-transfer-from/internal-transfer-from.module').then(
            (m) => m.InternalTransferFromModule,
          ),
      },
      {
        path: 'transfer-to',
        loadChildren: () =>
          import('./secure/internal-transfer-to/internal-transfer-to.module').then(
            (m) => m.InternalTransferToModule,
          ),
      },
      {
        path: '',
        loadChildren: () =>
          import('./secure/client-due-diligence/client-due-diligence.module').then(
            (m) => m.ClientDueDiligenceModule,
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(internalTransferRoutes)],
  exports: [RouterModule],
})
export class InternalTransferRoutingModule {}
